import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "sonner";

import Header from "@/components/aevos/Header";
import Footer from "@/components/aevos/Footer";
import WhatsAppFloat from "@/components/aevos/WhatsAppFloat";
import ScrollToTop from "@/components/aevos/ScrollToTop";
import GtmPageview from "@/components/aevos/GtmPageview";

import Home from "@/pages/Home";
import Sobre from "@/pages/Sobre";
import Metodo from "@/pages/Metodo";
import Planos from "@/pages/Planos";
import Tecnologia from "@/pages/Tecnologia";
import Mapeamento from "@/pages/Mapeamento";
import Parcerias from "@/pages/Parcerias";
import Contato from "@/pages/Contato";
import LpEmagrecimento from "@/pages/lp/Emagrecimento";

// Institutional site chrome (header/footer/float) — standalone LPs render outside this layout
const SiteLayout = () => (
  <>
    <Header />
    <main>
      <Outlet />
    </main>
    <Footer />
    <WhatsAppFloat />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <GtmPageview />
        <Routes>
          <Route path="/lp/emagrecimento" element={<LpEmagrecimento />} />
          <Route element={<SiteLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/sobre" element={<Sobre />} />
            <Route path="/metodo" element={<Metodo />} />
            <Route path="/planos" element={<Planos />} />
            <Route path="/tecnologia" element={<Tecnologia />} />
            <Route path="/mapeamento" element={<Mapeamento />} />
            <Route path="/parcerias" element={<Parcerias />} />
            <Route path="/contato" element={<Contato />} />
          </Route>
        </Routes>
        <Toaster richColors position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
